
export class AccountKeys {
    decryptedDbKey: string;
    packingKeyPassphrase: string;
    packingKeyCheck: string;
    packingKeyPublicKey: string;
    packingKeyDecryptedPrivateKey: string;
}